export default store => store.beautyRecommendations;
